/*****************************************************************
 ** Copyright (c) 帕加马直播预览
 ** 创建人:      Eugene
 ** 创建日期:    2020/10/10
 ** 修改人:
 ** 修改日期:
 ** 描 述: 全局只读配置
 **-----------------------------------------------------------------
 ******************************************************************/

import request from '@/utils/$x';

// 查询直播课程
export async function getLiveClassList(params) {
  return request.http('/livePlay/getLiveClassList', {
    method: 'post',
    data: params,
  });
}

// 创建直播课程
export async function createLiveClass(params) {
  return request.http('/livePlay/createLiveClass', {
    method: 'post',
    data: params,
  });
}

// 编辑直播课程
export async function editLiveClass(params) {
  return request.http('/livePlay/editLiveClass', {
    method: 'post',
    data: params,
  });
}

// 查看直播课程
export async function getLiveClassInfo(params) {
  return request.http('/livePlay/getLiveClassInfo', {
    method: 'post',
    data: params,
  });
}

// 后台课程统计接口
export async function getLiveClassStatisticsInfo(params) {
  return request.http('/livePlay/getLiveClassStatisticsInfo', {
    method: 'post',
    data: params,
  });
}

// 删除直播课程
export async function deleteLiveClass(params) {
  return request.http('/livePlay/deleteLiveClass', {
    method: 'post',
    data: params,
  });
}

// 修改课程上下架状态
export async function changeLiveClassStatus(params) {
  return request.http('/livePlay/changeLiveClassStatus', {
    method: 'post',
    data: params,
  });
}

// 强制违规主播下架
export async function letIllegalAnchorOffline(params) {
  return request.http('/livePlay/letIllegalAnchorOffline', {
    method: 'post',
    data: params,
  });
}

// 教练列表
export async function listCoach(params) {
  return request.http('/livePlay/listCoach', {
    method: 'post',
    data: params,
  });
}

// 查询课信息列表
export async function queryClassDetailList(params) {
  return request.http('/livePlay/queryClassDetailList', {
    method: 'post',
    data: params,
  });
}

// 直播取消
export async function cancelLiveClass(params) {
  return request.http('/livePlay/cancelLiveClass', {
    method: 'post',
    data: params,
  });
}

// 获取直播取消原因
export async function getCancelReason(params) {
  return request.http('/livePlay/getCancelReason', {
    method: 'post',
    data: params,
  });
}

// 获取有效渠道列表
export async function getLiveChannelEnableList(params) {
  return request.http('/livePlay/getLiveChannelEnableList', {
    method: 'post',
    data: params,
  });
}

// 获取推流地址
export async function getClassStreamUrl(params) {
  return request.http('/livePlay/getClassStreamUrl', {
    method: 'post',
    data: params,
  });
}

// 检查直播推流状态
export async function getStreamStatus(params) {
  return request.http('/livePlay/getStreamStatus', {
    method: 'post',
    data: params,
  });
}

// 前期工作完毕，可以开播
export async function liveStart(params) {
  return request.http('/livePlay/liveStart', {
    method: 'post',
    data: params,
  });
}

// 主播结束直播
export async function endLive(params) {
  return request.http('/livePlay/endLive', {
    method: 'post',
    data: params,
  });
}
